"use strict";
import { isValidEmail } from "./helpers";

init();

function init() {
    var dateFormat = "MMM DD, YYYY";
    var startDate = moment().format(dateFormat);
    var endDate = moment().add(1, 'day').format(dateFormat);
    var ROOM_IMAGE_PER_TYPE = {
        "Superior Room": {
            "thumbnail": '/static/img/rooms/superiorroom-thumbnail.jpg',
            "gallery": ['/static/img/rooms/superiorroom-1.jpg']
        },
        "De Luxe Room": {
            "thumbnail": '/static/img/rooms/deluxeroom1-thumbnail.jpg',
            "gallery": ['/static/img/rooms/deluxeroom1-1.png']
        },
        "Standard Twin Room": {
            "thumbnail": '/static/img/rooms/standardtwin-thumbnail.jpg',
            "gallery": ['/static/img/rooms/standardtwin-1.jpg']
        },
        "Standard Room": {
            "thumbnail": '/static/img/rooms/standard-thumbnail.jpg',
            "gallery": ['/static/img/rooms/standard-1.jpg']
        },
        "Mangrove Room": {
            "thumbnail": '/static/img/rooms/mangrove-thumbnail.jpg',
            "gallery": ['/static/img/rooms/mangrove-1.png']
        },
        "Capsule Room": {
            "thumbnail": '/static/img/rooms/capsule-thumbnail.jpg',
            "gallery": ['/static/img/rooms/capsule-1.jpg']
        },
        "Dorm 1": {
            "thumbnail": '/static/img/rooms/dorm1-thumbnail.jpg',
            "gallery": ['/static/img/rooms/dorm1-1.jpg', '/static/img/rooms/dorm1-2.jpg']
        },
        "Dorm 2": {
            "thumbnail": '/static/img/rooms/dorm2-thumbnail.jpg',
            "gallery": ['/static/img/rooms/dorm2-1.jpg', '/static/img/rooms/dorm2-2.jpg', '/static/img/rooms/dorm2-3.jpg', '/static/img/rooms/dorm2-4.jpg']
        }
    };

    if (window.checkInDate && window.checkOutDate) {
        if (moment(window.checkInDate, dateFormat).isValid() && moment(window.checkOutDate, dateFormat).isValid()) {
            startDate = window.checkInDate;
            endDate = window.checkOutDate;
        }
    }

    $("#checkIn").val(startDate);
    $("#checkOut").val(endDate);

    $(".js-checkout-date").daterangepicker({
        minDate: moment().format("MMM DD, YYYY"),
        maxSpan: {
            "days": 30
        },
        startDate: startDate,
        endDate: endDate,
        locale: {
            format: dateFormat
        }
    }, function (start, end, label) {
        $("#checkIn").val(start.format(dateFormat));
        $("#checkOut").val(end.format(dateFormat));
    });

    if(window.location.href.indexOf("/availability") != -1) {
        var LISTED_ROOMS = [];
        var SELECTED_ROOMS = [];
        var AVAILABLE_ROOMS = {};
        var GROUPED_ROOMS = {};
        var PAYPAL_INFO = {}
        availabilityPage();
        fillBookingSummary();
    }

    evtBtnSubmit();
    evtFormSubmit();
    evtSelectChange();
    evtCheckRequiredForms();

    function areAllRequiredFilled() {
        var flag = true;
        $(".js-required:not([type=radio])").each(function () {
            if (!$(this).val().trim()) flag = false;
        });

        if (!$("[name='payment_method']:checked").length ||
            !$("[name='payment_choice']:checked").length) {
            flag = false;
        }

        var $emailField = $("[name='email']");
        if ($emailField.val().trim().length > 0 &&
            !isValidEmail($emailField.val().trim())) {
            $emailField.addClass("op-error");
            $emailField.attr({
                "data-toggle": "tooltip",
                "data-placement": "bottom",
                "title": "Invalid email address."
            });

            $emailField.tooltip();
            flag = false;
        } else {
            $emailField.removeClass("op-error");
            $emailField.tooltip("dispose");
        }

        $(".js-continue").attr("disabled", "disabled");
        if (flag) {
            $(".js-continue").removeAttr("disabled");

            // filling booking details for confirmation
            $(".js-booking-detail:not([type=radio])").each(function () {

                // hide or show country
                if ($(this).attr("name") === "country") {
                    $(this).trigger("change");
                }

                $(".js-" + $(this).attr("name")).text($(this).val().trim());
            });

            // filling radio buttons
            $(".js-booking-detail:checked").each(function () {
                $(".js-" + $(this).attr("name")).text($(this).val().trim());
            });
        }
    }

    function evtCheckRequiredForms() {
        $(".js-required, [name=remarks]").on("keyup paste", function () {
            areAllRequiredFilled();
        });

        $("[name='payment_method']").on("change", function () {
            areAllRequiredFilled();
        });

        $("[name='payment_choice']").on("change", function () {
            areAllRequiredFilled();
        });
    }

    function evtBtnSubmit() {
        $('.js-btn-check').on("click", function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });

        $(document).on("click", ".js-step-btn", function () {
            $(".js-steps-indicator").removeClass("active");
            $(".js-step-indicator-" + $(this).val()).addClass("active");

            proceedTo($(this).val());
        });

        $(document).on('click', '.js-book-room', function () {
            bookThisRoom($(this));
        });

        $(document).on('click', '.js-remove-room', function () {
            removeThisSelectedRoom($(this));
        });

        $(document).on("click", ".js-submit-booking", function () {
            var $button = $(this);
            $button.button('loading');

            var rooms = {};
            SELECTED_ROOMS.forEach(function (r) {
                rooms[r.room_no] = {
                    "num_of_extra": r.num_of_extra,
                    "num_of_kids": r.num_of_kids,
                    "room_type": r.type,
                    "room_no": r.room_no,
                    "room_price": "Php " + r.price_per_night.amount.toLocaleString(),
                    "num_of_adults": r.num_of_adults
                }
            });

            var formData = {
                firstname: $("[name=firstname]").val().trim(),
                lastname: $("[name=lastname]").val().trim(),
                email: $("[name=email]").val().trim(),
                mobile_no: $("[name=mobile_no]").val().trim(),
                country: $("[name=country]").val().trim(),
                remarks: $("[name=remarks]").val().trim(),
                arrival: moment($("[name=checkin]").val(), "MMM DD, YYYY").format("MM/DD/YYYY"),
                departure: moment($("[name=checkout]").val(), "MMM DD, YYYY").format("MM/DD/YYYY"),
                eta: $("[name=eta]").val().trim(),
                rooms: JSON.stringify(rooms),
                payment_method: $("[name=payment_method]:checked").val().trim(),
                payment_choice: $("[name=payment_choice]:checked").val().trim(),
            };

            if (!$.isEmptyObject(PAYPAL_INFO)) {
                formData["paypal_info"] = JSON.stringify(PAYPAL_INFO)
            }

            // only add province if country is Philippines
            if (formData.country === "Philippines") {
                formData["province"] = $("[name=province]").val().trim();
            }

            formData['g-recaptcha-response'] = $("#g-recaptcha-response").val();

            $.post('/api/v1/booking/new', formData, function(response) {
                if(response.success) {
                    showConfirmation();
                } else {
                    alert(response.message);
                }

            }).always(function() {
                $button.button('reset');
            });
        });
    }

    function evtFormSubmit() {
        $("[name='form-check-avail']").on("submit", function (e) {
            e.preventDefault();

            if (window.checkInDate && window.checkOutDate) {
                if (!confirm('Are you sure you want to change dates? All your changes will be gone.')) {
                    return false;
                }
            }

            $(this)
                .find("[type='submit']")
                .button("loading");



            $(this)[0].submit();
        })
    }

    function evtSelectChange() {
        $("[name='country']").on("change", function () {
            if($(this).val() == "Philippines") {
                $(".js-province-wrapper").show();
            } else {
                $(".js-province-wrapper").hide();
            }
        });

        $("[name='country']").trigger("change");
    }

    function bookThisRoom($button) {
        $button.button("loading");

        var $parentCard = $button.parents("[data-room-type]");
        var selectedRoomType = GROUPED_ROOMS[$parentCard.data("room-type")];
        selectedRoomType.sort(function (a, b) {
            return parseInt(b.room_no.replace(/\D+/g, ''), 10) - parseInt(a.room_no.replace(/\D+/g, ''), 10);
        });

        var selected = selectedRoomType.pop();
        var $numOfAdults = $parentCard.find("[name='num_of_adults']");
        var $numOfKids = $parentCard.find("[name='num_of_kids']");
        var $numOfExtra = $parentCard.find("[name='num_of_extra']");

        selected["num_of_adults"] = $numOfAdults.val();
        selected["num_of_kids"] = $numOfKids.val();
        selected["num_of_extra"] = $numOfExtra.val();

        alert(selected.type + " added to the list.");
        SELECTED_ROOMS.push(selected);
        $numOfAdults
            .add($numOfKids)
            .add($numOfExtra)
            .val(0)

        $button.button("reset");

        renderSelectedRooms();
        checkRoomTypeAvailability();
    }

    function removeThisSelectedRoom($button) {
        if (confirm("Are you sure you want to remove this room?")) {
            var $parentCard = $button.parents("[data-room-type]");
            var removedRoom = SELECTED_ROOMS.splice(parseInt($parentCard.data("index")), 1)[0];

            delete removedRoom["num_of_adults"];
            delete removedRoom["num_of_kids"];
            delete removedRoom["num_of_extra"];

            GROUPED_ROOMS[$parentCard.data("room-type")].push(removedRoom);

            renderSelectedRooms();
            checkRoomTypeAvailability();
        }
    }

    function formatRoom(room) {
        var inclusions_html = '';
        room.inclusions.forEach(function (i) {
            inclusions_html += "<li> " + i + " </li>";
        });

        var adult_options = "";
        for (var i = 0; i <= room.capacity; i++) {
            adult_options += "<option value='" + i + "'>" + i + "</option>";
        }

        var extra_options = "";
        for (var i = 0; i <= room.extra; i++) {
            extra_options += "<option value='" + i + "'>" + i + "</option>";
        }

        var kids_options = "";
        for (var i = 0; i <= 5; i++) {
            kids_options += "<option value='" + i + "'>" + i + "</option>";
        }

        var room_gallery = '';
        ROOM_IMAGE_PER_TYPE[room.type].gallery.forEach(function (i) {
            room_gallery += "<a href='" + i + "' class='pt10'>View Photos</a>";
        });


        var roomCard = "\
        <div class='card op-card mb20' data-room-type='" + room.type + "'>\
            <div class='card-header'>\
                <h5 class='mb0'>" + room.type + "</h5>\
                <span class='op-price'>Php " + room.price_per_night.amount.toLocaleString() + " / night</span>\
            </div>\
            <div class='card-body'>\
                <div class='row'>\
                    <div class='col-sm-4'>\
                        <img src='" + ROOM_IMAGE_PER_TYPE[room.type].thumbnail + "' class='img-fluid' />\
                        <div class='availability-room-gallery js-room-gallery'> " + room_gallery + " </div>\
                    </div>\
                    <div class='col-sm-8'>\
                        <p class='mb20'> " + room.description + " </p>\
                        <label>Inclusions</label>\
                        <ul>" + inclusions_html + "\</ul>\
                        <hr />\
                        <div class='row'>\
                            <div class='col-xl-2 col-sm-4 form-group'>\
                                <label>Adults</label>\
                                <select name='num_of_adults' class='form-control'>" + adult_options + "</select>\
                            </div>\
                            <div class='col-xl-2 col-sm-4 form-group'>\
                                <label>Kids</label>\
                                <select name='num_of_kids' class='form-control'>" + kids_options + "</select>\
                            </div>\
                            <div class='col-xl-3 col-sm-4 form-group'>\
                                <label>Extra PAX</label>\
                                <select name='num_of_extra' class='form-control'>" + extra_options + "</select>\
                            </div>\
                            <div class='col-xl-5 form-group d-flex align-items-end mt20'>\
                                <button class='btn btn-block btn-outline ws-normal js-book-room' data-loading-text='<i class=\'fa fa-spin fa-spinner fa-fw\'></i>Adding'>Book Room</button>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
            </div>\
        </div>";

        return roomCard;
    }

    function loadingRooms() {
        $(".js-rooms-list").html("\
            <div class='text-center'>\
                <i class='fa fa-spin fa-spinner fa-fw fa-2x'></i>\
            </div>\
        ");
    }

    function groupRoom() {
        GROUPED_ROOMS = {};
        $.each(AVAILABLE_ROOMS, function (key, room) {
            if (!GROUPED_ROOMS[room.type])
                GROUPED_ROOMS[room.type] = [];

            room['room_no'] = key;
            GROUPED_ROOMS[room.type].push(room);
        });
    }

    function getAvailableRooms() {
        var start = moment($("#checkIn").val(), "MMM DD, YYYY").format("MM/DD/YYYY");
        var end = moment($("#checkOut").val(), "MMM DD, YYYY").format("MM/DD/YYYY");

        return $.get('/api/v1/rooms/available', {
            start: start,
            end: end
        });
    }

    function renderRooms() {
        var $roomsList = $(".js-rooms-list");
        var rooms_html = "";
        $.each(AVAILABLE_ROOMS, function (key, room) {
            if (LISTED_ROOMS.indexOf(room.type) !== -1) return true;

            LISTED_ROOMS.push(room.type);
            rooms_html += formatRoom(room);
        });

        var $rooms = $(rooms_html);
        $roomsList.html($rooms);

        // arrange rooms from highest to lowest room rates
        var arrangement = ['Superior Room', 'De Luxe Room', 'Standard Twin Room', 'Standard Room', 'Mangrove Room', 'Capsule Room', 'Dorm 2', 'Dorm 1'];
        arrangement.forEach(function (roomType) {
            var $room = $roomsList.find("[data-room-type='" + roomType + "']").detach();
            $roomsList.append($room);
        });
    }

    function checkRoomTypeAvailability() {
        $.each(GROUPED_ROOMS, function (room_type, rooms_available) {
            var $roomCard = $("[data-room-type='" + room_type + "']")
            if (rooms_available.length) {
                $roomCard.find(".js-book-room")
                    .text("Book Room")
                    .removeAttr("disabled")
            } else {
                $roomCard.find(".js-book-room")
                    .text("Fully Booked")
                    .attr("disabled", "disabled")
            }
        });
    }

    function fillBookingSummary() {
        var checkIn = $("#checkIn").val();
        var checkOut = $("#checkOut").val();
        $(".js-arrival-date-text").text(checkIn);
        $(".js-departure-date-text").text(checkOut);
        $(".js-num-nights-text").text(moment(checkOut, "MMM DD, YYYY").diff(moment(checkIn, "MMM DD, YYYY"), 'days'));
    }

    function renderSelectedRooms() {
        var checkIn = $("#checkIn").val();
        var checkOut = $("#checkOut").val();
        var numNights = moment(checkOut, "MMM DD, YYYY").diff(moment(checkIn, "MMM DD, YYYY"), 'days');

        var $selectedRooms = $(".js-selected-rooms-list");
        if (!SELECTED_ROOMS.length) {
            $(".js-proceed-next").attr("disabled", "disabled");
            $(".js-total-amount").text("Php 0.00 ");
            $selectedRooms.html("<p class='text-center'>You haven't selected a room.</p>");
            return;
        }

        $(".js-proceed-next")
            .removeAttr("disabled");

        var card_items = "";
        var total_amount_due = 0;
        SELECTED_ROOMS.forEach(function (r, idx) {
            var total = (r.price_per_night.amount * numNights) + (r.price_per_extra.amount * r.num_of_extra * numNights);

            total_amount_due += total;
            card_items += "\
            <div class='card-item' data-room-type='" + r.type + "' data-index='" + idx + "'>\
                <div class='d-flex justify-content-between'>\
                    <label>" + r.type + "</label>\
                    <span>Php " + total.toLocaleString() + "</span>\
                </div>\
                <small class='d-block mb5'>Php " + r.price_per_night.amount.toLocaleString() + " x " + numNights + " night/s</small>\
                <small class='d-block mb5'>(" + r.num_of_extra + " Extra PAX x Php " + r.price_per_extra.amount.toLocaleString() + ") x " + numNights + " night/s</small>\
                <button type='button' class='btn-ico --danger js-steps js-step-1 js-step-2 js-remove-room p10 pl0'><i class='material-icons'>delete</i>Remove Room</a>\
            </div>";
        });

        $(".js-total-amount").text("Php " + total_amount_due.toLocaleString());

        $selectedRooms.html(card_items);
    }

    function getTotalAmount() {
        var checkIn = $("#checkIn").val();
        var checkOut = $("#checkOut").val();
        var numNights = moment(checkOut, "MMM DD, YYYY").diff(moment(checkIn, "MMM DD, YYYY"), 'days');

        var total_amount_due = 0;
        SELECTED_ROOMS.forEach(function (r) {
            var total = (r.price_per_night.amount * numNights) + (r.price_per_extra.amount * r.num_of_extra * numNights);

            total_amount_due += total;
        });

        return total_amount_due;
    }


    function availabilityPage() {
        loadingRooms();

        getAvailableRooms().then(function (response) {
            if (response.success) {
                AVAILABLE_ROOMS = response.data;
                groupRoom();
                renderRooms();
                renderSelectedRooms();
                checkRoomTypeAvailability();

                $('.js-room-gallery').each(function() { // the containers for all your galleries
                    $(this).magnificPopup({
                        delegate: 'a', // the selector for gallery item
                        type: 'image',
                        gallery: {
                          enabled:true
                        }
                    });
                });
            }
        });
    }

    function showConfirmation() {
        $(".js-content").html("\
            <div class='container text-center'>\
                <div class='row mt70'>\
                    <div class='col-md-8 offset-md-2'>\
                        <h3>Awesome!</h3>\
                        <em class='d-block mb30'>Thank you so much for booking with us at Ocean Pearl Cove Resort - Tabango.</em>\
                        <p class='mb80'>\
                            We have sent your booking details to the email you provided. If you do not receive an email, please check your Spam folder just in case the email got delivered there instead of your inbox. We will also get in touch with you through email or phone for more details on your booking.\
                            If you have any concerns please contact us by clicking <a href='/contact-us'>here</a>.\
                        </p>\
                        <a href='/' class='btn btn-primary'>Return to Home Page</a>\
                    </div>\
                </div>\
            </div>");
    }

    function paypalButton() {
        var amt = getTotalAmount();
        var paymentType = $("[name='payment_choice']:checked").val();
        if (paymentType !== "Full Payment") {
            amt /= 2;
        }

        $(".js-submit-booking").attr("disabled", "disabled");

        $(".js-payment-wrapper").html("\
            <p class='mb20'>Please complete the booking process by paying an amount of <strong>Php " + amt.toLocaleString() + "</strong> as a <strong>" + paymentType + "</strong> for this booking.</p>\
            <div id='payBtn'></div>")

        paypal.Button.render({
            env: 'production',
            client: {
                sandbox: 'AXwkv7g1VLPA5bFfwz2Xi-4R03LsWUrEM54Bk7SRNFVIZte9iXA7xUpTomfbxXEBWTnNCL4Bk-F8Ktqa',
                production: 'Ae0cAHjjZ7GTBN0I8s4L553tTqpKlAnDhigm2AHSIusHQpmvtpXXmpd-OodI0AQJEa5Ircr93wWylY66'
            },
            style: {
                size: 'medium',
                color: 'gold',
                shape: 'pill',
                label: 'checkout',
                tagline: 'true'
            },
            commit: true,
            payment: function (data, actions) {
                return actions.payment.create({
                    transactions: [{
                        amount: {
                            total: amt,
                            currency: 'PHP'
                        }
                    }]
                });
            },
            onAuthorize: function (data, actions) {
                PAYPAL_INFO = data;
                return actions.payment.execute()
                    .then(function () {
                        window.alert('Thank you for your purchase!');
                        $(".js-step-btn").attr("disabled", "disabled");
                        $(".js-submit-booking").
                            removeAttr("disabled").
                            trigger("click");

                        $(".js-content").html();
                    });
            }
        }, '#payBtn');
    }

    function bankTransfer() {
        var amt = getTotalAmount();
        var paymentType = $("[name='payment_choice']:checked").val();
        if (paymentType !== "Full Payment") {
            amt /= 2;
        }

        $(".js-submit-booking").removeAttr("disabled");
        $(".js-payment-wrapper").html("\
            <p>Please transfer amount of <strong>Php " + amt.toLocaleString() + "</strong> as a <strong>" + paymentType + "</strong> for this booking.\
            <br/><strong>We will send you our bank details where you can transfer the payments.</strong></p>");
    }

    function confirmationDetails() {
        var payment_method = $("[name=payment_method]:checked").val()
        if (payment_method == "PayPal") {
            paypalButton();
        } else {
            bankTransfer();
        }
    }

    function proceedTo(step) {
        $(".js-steps").hide(0, function () {
            $(".js-step-" + step).show();
        });

        confirmationDetails();
    }
}
